function createStory(shortName, title, preview, author, story) {
    return {
        shortName: shortName,
        title: title,
        preview: preview,
        author: author,
        story: story
    };
}

export default createStory;